<template>
    <div class="order-page-container">
        <cc-loader-full v-if="loading" />
        <div class="page-route-select">
            <router-link
                to="/cliente/monitores/cotacoes"
                class="page-route-select-text"
            >
                Home
            </router-link>
            <span class="material-icons-round page-route-select-icon"
                >play_arrow</span
            >
            <div class="page-route-select-text">Pedidos</div>
        </div>
        <div class="order-page-title">Pedidos</div>
        <div class="order-page-info-containear">
            <!-- mobile -->
            <div class="mobile mobile-buttons-row">
                <Button
                    style="width: 40%"
                    class="mobile mobile-filter-button"
                    :text="
                        !showMobileFilter
                            ? 'Mostrar filtros'
                            : 'Esconder filtros'
                    "
                    :iconName="'settings'"
                    :action="() => (showMobileFilter = !showMobileFilter)"
                />
                <Button
                    :disabled="true"
                    style="width: 40%"
                    :class="{ 'hide-mobile-filters': !showMobileFilter }"
                    :text="'Imprimir'"
                    :iconName="'print'"
                    :action="printClick"
                />
            </div>
            <OrderPartial
                v-if="order_data"
                :order_data="order_data"
                :printColapsed="printColapsed"
            />
        </div>
        <!-- desktop -->
        <div class="desktop order-page-filter-section2">
            <StandardInputAuto
                :action="setCompany"
                :title="'Empresa'"
                :width="'18vw'"
                :type="'select'"
                :selectWidth="'36vw'"
                :placeholder="'Selecione a empresa'"
                :list="arraySelectLoja"
            />
            <StandardInputAuto
                :action="setSuplier"
                :title="'Fornecedor'"
                :width="'18vw'"
                :type="'select'"
                :placeholder="'Selecione o fornecedor'"
                :list="arraySelectFornecedor"
            />
            <StandardInputAuto
                :action="setStatus"
                :title="'Status'"
                :width="'18vw'"
                :type="'select'"
                :selectWidth="'36vw'"
                :placeholder="'Selecione o status'"
                :list="statuses"
            />
            <StandardInputAuto
                :placeholder="'Selecione'"
                :action="setIdentifier"
                :width="'18vw'"
                :type="'text'"
                :title="$store.state.identifierText"
            />
            <StandardInputAuto
                class="desktop"
                :action="setOrderSearch"
                :title="'Nº do Pedido'"
                :width="'18vw'"
                :type="'text'"
            />
            <StandardInputAuto
                class="desktop"
                :action="setCotacao"
                :title="'Nº da Cotação'"
                :width="'18vw'"
                :type="'text'"
            />
        </div>
        <!-- mobile -->
        <div class="mobile order-page-filter-section2">
            <StandardInputAuto
                :action="setCompany"
                :title="'Empresa'"
                :width="'49%'"
                :selectWidth="'45%'"
                :type="'select'"
                :placeholder="'Selecione a empresa'"
                :list="arraySelectLoja"
            />
            <StandardInputAuto
                :action="setSuplier"
                :title="'Fornecedor'"
                :width="'49%'"
                :type="'select'"
                :placeholder="'Selecione o fornecedor'"
                :list="arraySelectFornecedor"
            />
            <!-- <StandardInputListFiltered
        :action="setSuplier"
        :title="'Fornecedor'"
        :width="'49%'"
        :selectWidth="'45%'"
        :placeholder="'Selecione o fornecedor'"
        :list="arraySelectFornecedor"
      /> -->
        </div>
        <StandardInputAuto
            class="mobile"
            :class="{ 'hide-mobile-filters': !showMobileFilter }"
            :action="setStatus"
            :title="'Status'"
            :width="'100%'"
            :type="'select'"
            :selectWidth="'100%'"
            :placeholder="'Selecione o status'"
            :list="statuses"
        />
        <div
            class="order-page-filter-section1"
            :class="{ 'hide-mobile-filters': !showMobileFilter }"
        >
            <div class="page-filters__right-wrapper">
                <div class="page-filters__right-title-wrapper">
                    <div class="page-filters__right-title">Data Inicial</div>
                </div>
                <div class="page-filters__right-select-wrapper end-date">
                    <datetime
                        style="border-radius: 8px !important"
                        class="form-control"
                        ref="datepicker"
                        v-model="dateInit"
                        auto
                        type="date"
                    ></datetime>
                    <span
                        @click="open_datepicker(0)"
                        class="material-icons-outlined date-icon"
                    >
                        today
                    </span>
                </div>
            </div>

            <div class="page-filters__right-wrapper">
                <div class="page-filters__right-title-wrapper">
                    <div class="page-filters__right-title">Data Final</div>
                </div>
                <div class="page-filters__right-select-wrapper end-date">
                    <datetime
                        style="border-radius: 8px !important"
                        class="form-control"
                        ref="datepicker"
                        v-model="dateEnd"
                        auto
                        type="date"
                    ></datetime>
                    <span
                        @click="open_datepicker(1)"
                        class="material-icons-outlined date-icon"
                    >
                        today
                    </span>
                </div>
            </div>
            <div class="page-filters__right-wrapper">
                <div class="page-filters__right-title-wrapper">
                    <div class="page-filters__right-title">Entrega Inicial</div>
                </div>
                <div class="page-filters__right-select-wrapper end-date">
                    <datetime
                        style="border-radius: 8px !important"
                        class="form-control"
                        ref="datepicker"
                        v-model="deliveryInit"
                        auto
                        type="date"
                    ></datetime>
                    <span
                        @click="open_datepicker(2)"
                        class="material-icons-outlined date-icon"
                    >
                        today
                    </span>
                </div>
            </div>

            <div class="page-filters__right-wrapper">
                <div class="page-filters__right-title-wrapper">
                    <div class="page-filters__right-title">Entrega Final</div>
                </div>
                <div class="page-filters__right-select-wrapper end-date">
                    <datetime
                        style="border-radius: 8px !important"
                        class="form-control"
                        ref="datepicker"
                        v-model="deliveryEnd"
                        auto
                        type="date"
                    ></datetime>
                    <span
                        @click="open_datepicker(3)"
                        class="material-icons-outlined date-icon"
                    >
                        today
                    </span>
                </div>
            </div>
            <StandardInputAuto
                class="mobile"
                style="margin-right: 1.5vw"
                :action="setOrderSearch"
                :title="'Nº do Pedido'"
                :width="'56vw'"
                :type="'text'"
            />
            <StandardInputAuto
                class="mobile"
                style="margin-right: 1.5vw"
                :action="setCotacao"
                :title="'Nº da Cotação'"
                :width="'56vw'"
                :type="'text'"
            />
        </div>
        <!-- <div class="selected-options-containear">
      <div class="selected-option" v-if="buscaPedido">
        <div>{{ buscaPedido }}</div>
        <span
          class="material-icons"
          style="cursor: pointer"
          v-on:click="() => (buscaPedido = undefined)"
          >close</span
        >
      </div>
      <div class="selected-option" v-if="identifier">
        <div>{{ identifier }}</div>
        <span
          class="material-icons"
          style="cursor: pointer"
          v-on:click="() => setIdentifier('')"
          >close</span
        >
      </div>
      <div class="selected-option" v-if="buscaCotacao">
        <div>{{ buscaCotacao }}</div>
        <span
          class="material-icons"
          style="cursor: pointer"
          v-on:click="() => setCotacao(undefined)"
          >close</span
        >
      </div>
      <div class="selected-option" v-if="selectedLoja">
        <div>{{ selectedLoja.loj_nomeFantasia }}</div>
        <span
          class="material-icons"
          style="cursor: pointer"
          v-on:click="
            () => {
              if (!lockStore) selectedLoja = '';
            }
          "
          >close</span
        >
      </div>
      <div class="selected-option" v-if="selectedFornecedor">
        <div>{{ selectedFornecedor.for_nome }}</div>
        <span
          class="material-icons"
          style="cursor: pointer"
          v-on:click="() => setSuplier(undefined)"
          >close</span
        >
      </div>
      <div class="selected-option" v-if="filters.status">
        <div>{{ filters.status }}</div>
        <span
          class="material-icons"
          style="cursor: pointer"
          v-on:click="() => (filters = {})"
          >close</span
        >
      </div>
    </div> -->
        <div class="buttons">
            <Button
                class="print-button"
                :text="'Exportar TXT'"
                :iconName="'description'"
                :action="exportTxt"
            />
            <Button
                class="print-button"
                :text="'Imprimir'"
                :iconName="'print'"
                :action="printClick"
            />
            <Button
                class="filter-button"
                :text="'Filtrar'"
                :iconName="'search'"
                :action="filtrarPedidos"
            />
        </div>
        <div class="table-container">
            <table class="order-table">
                <thead>
                    <tr>
                        <th class="checkbox-width">
                            <span
                                v-if="isAllCheck"
                                @click="checkAll(false)"
                                class="material-icons-outlined"
                                >check_box</span
                            >
                            <span
                                v-else
                                @click="checkAll(true)"
                                class="material-icons-outlined"
                                >check_box_outline_blank</span
                            >
                        </th>
                        <th>ID</th>
                        <th>Cotação</th>
                        <th>Loja</th>
                        <th>Fornecedor</th>
                        <th>Vendedor</th>
                        <th>Condição</th>
                        <th class="value-width">Valor (R$)</th>
                        <th v-if="canCancelOrder">Economia</th>
                        <th>Status</th>
                        <!-- <th>Whatsapp</th> -->
                        <th>Status ERP</th>
                        <th>Criação</th>
                        <th>Confirmação</th>
                        <th>Entrega</th>
                        <th>Recebimento</th>
                        <th>Avaliação</th>
                        <th class="actions-width">Ações</th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="(data, index) in arrayPedido"
                        :key="index"
                        :class="getSpecialBackground(index)"
                    >
                        <!-- CHECKBOX -->
                        <td class="checkbox-width">
                            <span
                                v-if="data.isCheck"
                                @click="togleCheck(data)"
                                class="material-icons-outlined"
                                >check_box</span
                            >
                            <span
                                v-else
                                @click="togleCheck(data)"
                                class="material-icons-outlined"
                                >check_box_outline_blank</span
                            >
                        </td>

                        <td>
                            <!-- <router-link
                v-if="data.order_id"
                :to="{
                  name: 'subrequest',
                  params: {
                    return_to: 'monitors-page',
                    id: data.id_cotacao,
                    seller_id: data.usu_id,
                    store_id: data.id_loja,
                    tab: 'pedidos',
                    provider_id: data.for_id,
                  },
                }"
                target="_blank"
              >
                <a >{{ data.id_pedido }}</a>
              </router-link>
              <router-link
                v-else
                :to="{
                  name: 'order-info',
                  params: {
                    backRouteName: 'monitors-page',
                    id: data.id_cotacao,
                    sellerid: data.usu_id,
                    sid: data.id_loja,
                    providerid: data.for_id,
                  },
                  query: { backRoute: 2 },
                }"
                target="_blank"
              >
              </router-link> -->
                            <span>{{ data.id_pedido }}</span>
                        </td>
                        <td>
                            <!-- <router-link
                :to="'/cliente/monitores/vencedores/' + data.id_cotacao"
                target="_blank"
              >
                <a>{{ data.id_cotacao }}</a>
              </router-link> -->
                            <span>{{ data.id_cotacao }}</span>
                        </td>

                        <!-- LOJA -->
                        <td>
                            <strong>
                                {{ data.loj_descricao }}
                            </strong>
                            <br />
                            {{ formatCNPJ(data.loj_cnpj) }}
                        </td>

                        <!-- FORNECEDOR -->
                        <td>
                            <span
                                :title="
                                    data.fornecedor
                                        ? data.fornecedor.for_nome
                                        : ''
                                "
                            >
                                <strong>
                                    {{
                                        data.fornecedor
                                            ? truncateText(
                                                  data.fornecedor.for_nome,
                                                  20
                                              )
                                            : "--"
                                    }}
                                </strong>
                            </span>
                            <br />
                            {{
                                data.fornecedor
                                    ? formatCNPJ(data.fornecedor.for_cnpj)
                                    : ""
                            }}
                        </td>
                        <!--  VENDEDOR  -->
                        <td>
                            <span :title="data.vendedor">
                                {{ truncateText(data.vendedor, 14) }}
                            </span>
                            <br />
                            <div
                                class="preorder-zap-container"
                                :class="{
                                    'preorder-zap-hover': data.usu_telefone,
                                }"
                            >
                                <i class="fab fa-whatsapp"></i>
                                <a
                                    v-if="data.usu_telefone"
                                    class="preorder-zap-link"
                                    :href="
                                        'https://api.whatsapp.com/send?phone=' +
                                        data.usu_telefone
                                    "
                                    target="_blank"
                                    >{{ formatPhone(data.usu_telefone) }}</a
                                >
                            </div>
                        </td>
                        <!-- CONDIÇÃO -->
                        <td>
                            {{ data.forma }}
                        </td>
                        <!-- VALOR -->
                        <td class="value-width">
                            <strong>
                                {{ data.valor_pedido | currency }}
                            </strong>
                        </td>
                        <!-- BALANCE -->
                        <td v-if="canCancelOrder" class="value-width">
                            <span
                                :class="
                                    data.balance >= 0
                                        ? 'value-badge'
                                        : 'negative-badge'
                                "
                            >
                                {{ data.balance | currency }}
                            </span>
                        </td>

                        <!-- STATUS -->
                        <td>
                            <div class="status-cell">
                                <template v-if="data.status === 'C'">
                                    <template
                                        v-if="
                                            data.status_recebido &&
                                            (data.divergencia.length > 0 ||
                                                data.divergencia_produto
                                                    .length > 0)
                                        "
                                    >
                                        <span
                                            class="material-symbols-outlined whatsapp-error"
                                            title="Pedido recebido com divergência!"
                                        >
                                            check_circle_unread
                                        </span>
                                        <span class="status-text whatsapp-error"
                                            >Divergência</span
                                        >
                                    </template>
                                    <template v-else-if="data.status_recebido">
                                        <span
                                            class="material-icons-round"
                                            title="Pedido recebido!"
                                            style="color: #30aa4c"
                                        >
                                            check_circle
                                        </span>
                                        <span class="status-text integration-ok"
                                            >Entregue</span
                                        >
                                    </template>
                                    <template v-else>
                                        <span
                                            class="material-icons-round"
                                            title="Pedido confirmado pelo vendedor mas não recebido"
                                            style="
                                                color: #30aa4c;
                                                cursor: default;
                                            "
                                        >
                                            check_circle
                                        </span>
                                        <span class="status-text integration-ok"
                                            >Confirmado</span
                                        >
                                    </template>
                                </template>
                                <template v-else>
                                    <span
                                        class="material-icons-round"
                                        style="color: orange"
                                        title="Não confirmado"
                                    >
                                        schedule
                                    </span>
                                    <span class="status-text status-pending"
                                        >Pendente</span
                                    >
                                </template>
                            </div>

                            <!-- entrega -->
                        </td>
                        <!-- <td>
              <div class="status-cell">
                <template v-if="data.whatsapp_status === 'read'">
                  <span
                    class="material-icons whatsapp-read"
                    :title="'Enviado: ' + data.whatsapp_sent + '\nEntregue: ' + data.whatsapp_delivered + '\nLido: ' + data.whatsapp_read"
                  >
                    done_all
                  </span>
                  <span class="status-text whatsapp-read">Lido</span>
                </template>

                <template v-else-if="data.whatsapp_status === 'delivered'">
                  <span
                    class="material-icons whatsapp-tick"
                    :title="'Enviado: ' + data.whatsapp_sent + '\nEntregue: ' + data.whatsapp_delivered"
                  >
                    done_all
                  </span>
                  <span class="status-text whatsapp-tick">Entregue</span>
                </template>

                <template v-else-if="data.whatsapp_status === 'sent'">
                  <span
                    class="material-icons whatsapp-tick"
                    :title="'Enviado: ' + data.whatsapp_sent"
                  >
                    check
                  </span>
                  <span class="status-text whatsapp-tick">Enviado</span>
                </template>

                <template v-else>
                  <span
                    class="material-icons whatsapp-error"
                    title="Mensagem não enviada"
                  >
                    error
                  </span>
                  <span class="status-text whatsapp-error">Erro</span>
                </template>
              </div>
            </td> -->

                        <td>
                            <div class="status-cell">
                                <!-- NÃO INTEGRADO -->
                                <template v-if="!data.vf_integration_status">
                                    <span
                                        class="material-icons-round integration-pending"
                                        :title="
                                            data.vf_integration_obs ||
                                            'Aguardando'
                                        "
                                    >
                                        schedule
                                    </span>
                                    <span
                                        class="status-text integration-pending"
                                        >Pendente</span
                                    >
                                </template>
                                <!-- ERRO NA INTEGRAÇÃO -->
                                <template
                                    v-else-if="
                                        data.vf_integration_status !==
                                        'INTEGRATED'
                                    "
                                >
                                    <span
                                        class="material-icons-round whatsapp-error"
                                        :title="
                                            data.vf_integration_obs ||
                                            'Falha de integração'
                                        "
                                        @click="
                                            edit_product(provider, seller);
                                            showNewProductModal = true;
                                        "
                                    >
                                        error
                                    </span>
                                    <span class="status-text whatsapp-error"
                                        >Erro</span
                                    >
                                </template>

                                <!-- OK -->
                                <template v-else-if="!data.vf_integration_obs">
                                    <span
                                        class="material-icons-round"
                                        :title="
                                            'Sincronizado #' +
                                            data.external_reference
                                        "
                                        style="color: #30aa4c; cursor: default"
                                        >check_circle</span
                                    >
                                    <span class="status-text integration-ok"
                                        >Integrado</span
                                    >
                                </template>

                                <!-- COM ALERTA -->
                                <template v-else>
                                    <span
                                        class="material-icons-round warning"
                                        :title="
                                            'Sincronizado #' +
                                            data.external_reference +
                                            '\nObs: ' +
                                            data.vf_integration_obs
                                        "
                                        style="color: #30aa4c; cursor: default"
                                        >warning</span
                                    >
                                    <span class="status-text warning"
                                        >Integrado</span
                                    >
                                </template>
                            </div>
                        </td>

                        <!-- DATA -->
                        <td>{{ getDateTime(data.data_geracao) }}</td>

                        <!-- DATA CONFIRMAÇÃO -->
                        <td>{{ getDateTime(data.data_confirmacao) }}</td>

                        <!-- DATA ENTREGA -->
                        <td>{{ getDate(data.data_entrega) }}</td>

                        <!-- DATA RECEBIMENTO -->
                        <td>{{ getDateTime(data.data_recebimento) }}</td>

                        <!-- AVALIAÇÃO -->
                        <td>{{ data.nota ? data.nota : "--" }}</td>

                        <!-- AÇÕES -->
                        <td class="actions-width">
                            <!-- BURGER -->
                            <span
                                class="material-icons-round"
                                style="cursor: pointer; font-size: 1.8em"
                                @click.stop="toggleMenu(index)"
                            >
                                more_vert
                            </span>

                            <!-- MENU -->
                            <div
                                v-if="openMenuIndex === index"
                                class="actions-dropdown"
                            >
                                <div
                                    v-if="
                                        data.status === 'C' &&
                                        !data.status_recebido
                                    "
                                    @click="confirm_delivery(data, index)"
                                    class="dropdown-item success"
                                >
                                    <span class="material-icons-round"
                                        >inventory</span
                                    >
                                    Confirmar Entrega
                                </div>
                                <div
                                    v-if="
                                        data.status === 'P' &&
                                        !data.status_recebido
                                    "
                                    @click="
                                        confirm_delivery_status_p(data, index)
                                    "
                                    class="dropdown-item success"
                                >
                                    <span class="material-icons-round"
                                        >done</span
                                    >
                                    Confirmar Pedido
                                </div>
                                <div
                                    v-if="data.status_recebido"
                                    @click="sendToDivergency(data)"
                                    class="dropdown-item"
                                >
                                    <span class="material-icons-round warning"
                                        >warning</span
                                    >
                                    Informar Divergência
                                </div>
                                <div @click="show(index)" class="dropdown-item">
                                    <span class="material-icons-round star"
                                        >star</span
                                    >
                                    Avaliar Vendedor
                                </div>
                                <div
                                    v-if="can('ORDER', 'SEND_NOTIFICATION')"
                                    @click="resend_notification(data.id_pedido)"
                                    class="dropdown-item"
                                >
                                    <span
                                        class="material-icons-round status-pending"
                                        >campaign</span
                                    >
                                    Reenviar notificação
                                </div>

                                <a
                                    :href="
                                        'https://api.whatsapp.com/send?phone=' +
                                        data.usu_telefone
                                    "
                                    target="_blank"
                                >
                                    <div
                                        v-if="data.usu_telefone"
                                        class="dropdown-item"
                                    >
                                        <i
                                            class="fab fa-whatsapp material-icons-round preorder-zap-hover"
                                        ></i>
                                        Falar Com vendedor
                                    </div>
                                </a>

                                <div @click="print(data)" class="dropdown-item">
                                    <span class="material-icons-round pdf"
                                        >picture_as_pdf</span
                                    >
                                    Exportar PDF
                                </div>
                                <div
                                    v-if="
                                        data.vf_integration_status &&
                                        data.vf_integration_status !==
                                            'INTEGRATED'
                                    "
                                    @click="resyncOrder(data.id_pedido)"
                                    class="dropdown-item"
                                >
                                    <span class="material-icons-round"
                                        >sync</span
                                    >
                                    Reenviar para o ERP
                                </div>

                                <div
                                    v-if="canCancelOrder"
                                    @click="cancelOrderButton(data)"
                                    class="dropdown-item danger"
                                >
                                    <span class="material-icons-round"
                                        >cancel</span
                                    >
                                    Cancelar Pedido
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="order-table-footer">
            <cc-pagination
                classes="orange"
                :items_by_page_value="items_by_page_value"
                :total="total_items"
                :page="paginaAtual"
                @change="updatePage($event)"
            ></cc-pagination>
        </div>

        <modal
            name="hello-world"
            classes="v--modal modal-avaliar "
            styles="margin: 30px auto;left: 0px !important;position: inherit !important;"
            height="600px"
            :clickToClose="false"
        >
            <div class="container modalBorder">
                <div class="d-flex justify-content-end">
                    <h1 class="closeModal p-1" @click="hide">X</h1>
                </div>
                <h4 class="modalTitlulo pb-3 pt-2 text-center">
                    Como foi sua experiência com
                    <span class="modalTituloNome">{{ indexArray }}</span> ?
                </h4>
                <div class="d-flex justify-content-center">
                    <star-rating
                        @rating-selected="modalClick"
                        v-model="rating"
                        :star-size="50"
                        :show-rating="false"
                    ></star-rating>
                </div>
                <div>
                    <div class="d-flex justify-content-center py-3">
                        <h1 class="notaVendedor">{{ notaVendedor }}</h1>
                    </div>
                    <div class="d-flex justify-content-center py-2">
                        <h5 class="subTitulo">
                            Escolha um ou mais problemas que você encontrou:
                        </h5>
                    </div>
                    <div class="d-flex justify-content-center py-2">
                        <form class="formModal">
                            <div
                                class="form-group"
                                v-for="(data, key) in arrayCheckbox"
                                :key="data.id"
                            >
                                <div class="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        :name="data.descricao"
                                        :id="data.id"
                                        :checked="checkbox[key] == data.id"
                                        v-model="checkbox[key]"
                                    />
                                    <label
                                        class="custom-control-label"
                                        :for="data.id"
                                        >{{ data.descricao }}</label
                                    >
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="d-flex justify-content-center pb-2">
                        <h5 class="subTitulo">
                            Sua avaliação é feita de forma anônima.
                        </h5>
                    </div>
                    <div class="d-flex justify-content-center pt-2">
                        <button
                            class="btnFeedback"
                            @click="postAvaliacaoPedido"
                        >
                            Enviar Feedback
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Button from "@/components/ui/buttons/Standard-Button.vue";
import OrderService from "@/services/OrderService";
import V2OrderService from "@/services/v2/order.service";
import V3OrderService from "@/services/v3/order.service";
import RequestService from "@/services/v3/request.service";
import * as CONSTANTS from "@/constants/constants";
import DirectOrdersSubTab from "./_direct_orders.subtab";
import MobileNote from "@/components/notes/mobile-promotion.noteV2";
import StandardInputAuto from "@/components/ui/inputs/StandardInputAuto.vue";
import StandardInputListFiltered from "@/components/ui/inputs/StandardInputListFiltered.vue";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import QuotationService from "@/services/OrderService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import OrderPartial from "@/components/partials/_print_order.partial";
import SellersService from "@/services/v2/sellers.service";
import Paginacao from "@/components/cliente/base-components/Pagination";
import { perm_mixin } from "@/mixins/permission.mixin";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import { mapState } from "vuex";

export default {
    mixins: [loaderMixin, perm_mixin],
    props: {
        request_id: {
            type: Number,
        },
    },
    components: {
        "cc-direct-orders-subtab": DirectOrdersSubTab,
        Button,
        MobileNote,
        StandardInputAuto,
        StandardInput,
        OrderPartial,
        "cc-pagination": Paginacao,
        StandardInputListFiltered,
    },
    data() {
        return {
            page: 1,
            showPagination: false,
            orders: [],
            CONSTANTS: CONSTANTS,
            items_by_page_value: 50,
            service: new OrderService(),
            orderService: new QuotationService(),
            svc: new SellersService(),
            v2orderService: new V2OrderService(),
            v3orderService: new V3OrderService(),
            req_svc: new RequestService(),
            dateInit: moment().subtract(30, "days").format("YYYY-MM-DD"),
            dateEnd: moment().add(1, "days").format("YYYY-MM-DD"),
            deliveryInit: null,
            deliveryEnd: null,
            printColapsed: undefined,
            is_loading_pdf: false,
            showMobileFilter: false,
            selectPedidos: [],
            arrayPedido: [],
            order_data: null,
            current_order: null,
            lockStore: false,
            buscaPedido: null,
            arraySelectLoja: [],
            filters: {},
            arraySelectFornecedor: [],
            selectedLoja: "",
            statuses: [
                { value: "P", text: "Pendente" },
                { value: "C", text: "Confirmado" },
                { value: "D", text: "Entregue" },
                { value: "ND", text: "Não Entregue" },
            ],
            identifier: "",
            isAllCheck: false,
            indexArray: "",
            indexIdPedido: null,
            rating: 0,
            checkbox: [],
            arrayCheckbox: null,
            notaVendedor: null,
            total_items: 1000,
            paginaAtual: 1,
            loading: true,
            isCancelling: false,
            openMenuIndex: null,
        };
    },
    computed: {
        selectedFornecedor() {
            return this.$store.state.selectedFornecedor;
        },
        buscaCotacao() {
            return this.$store.state.buscaCotacao;
        },
        ...mapState(["user"]),

        canCancelOrder() {
            const user = this.user || {};
            return !user.perms?.some(
                (perm) =>
                    perm.resource === "REQUEST_ORDER" &&
                    perm.action === "CANCEL" &&
                    perm.subject_ids === null
            );
        },
    },
    methods: {
        cancelOrderButton(orderData) {
            if (this.canCancelOrder) {
                this.cancelOrder(orderData);
            } else {
                this.$toast.error(
                    "❌ Você não tem permissão para cancelar pedidos."
                );
            }
        },
        async cancelOrder(orderData) {
            try {
                this.isCancelling = true;

                const { value: motivoId, isConfirmed } = await this.$swal.fire({
                    title: "Tem certeza que deseja cancelar este pedido?",
                    icon: "warning",
                    input: "select",
                    inputOptions: {
                        1: "Quantidade Errada",
                        2: "Valores Divergentes",
                        3: "Ruptura de Produtos",
                        4: "Entrega não realizada",
                        5: "Outros",
                    },
                    inputPlaceholder: "Selecione um motivo",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Sim, cancelar",
                    cancelButtonText: "Não",
                    inputValidator: (value) => {
                        if (!value) {
                            return "Você precisa escolher um motivo!";
                        }
                    },
                });

                if (!isConfirmed) return;

                const response = await axios.post(
                    `${CONSTANTS.API_URL}/cancelarpedido`,
                    {
                        loja: orderData.id_loja.toString(),
                        numeroCotacao: orderData.id_cotacao.toString(),
                        numeroPedido: orderData.id_pedido.toString(),
                        vendedor: orderData.usu_id.toString(),
                        motivoId: motivoId,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "token"
                            )}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.status >= 200 && response.status < 300) {
                    if (this.$toast?.success) {
                        this.$toast.success(
                            "✅ Pedido cancelado com sucesso!",
                            {
                                position: "top-right",
                                duration: 3000,
                            }
                        );
                    } else {
                        await this.$swal.fire({
                            title: "Sucesso!",
                            text: "Pedido cancelado com sucesso!",
                            icon: "success",
                            confirmButtonText: "OK",
                        });
                    }
                    await this.reloadOrders?.();
                }
            } catch (error) {
                if (this.$toast?.error) {
                    this.$toast.error("❌ Falha ao cancelar pedido", {
                        position: "top-right",
                        duration: 3000,
                    });
                } else {
                    await this.$swal.fire({
                        title: "Erro!",
                        text: "Falha ao cancelar pedido",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } finally {
                this.isCancelling = false;
            }
        },
        open_datepicker(idx) {
            document.getElementsByClassName("vdatetime-input")[idx].click();
        },
        checkAll(value) {
            this.arrayPedido.forEach((element) => (element.isCheck = value));
            this.isAllCheck = value;
        },
        setIdentifier(value) {
            this.identifier = value;
        },
        getSpecialBackground(index) {
            return;
            if (index % 2 != 0) return "page-table-line-special";
            return "white-bg";
        },
        togleCheck(data) {
            data.isCheck = !data.isCheck;
            if (!data.isCheck) this.isAllCheck = false;
            this.$forceUpdate();
        },
        getDate(date) {
            if (date) {
                return moment(String(date)).format("DD/MM/YYYY");
            } else {
                return "--";
            }
        },
        getDateTime(date) {
            if (date) {
                return moment(String(date)).format("DD/MM/YYYY HH:mm");
            } else {
                return "--";
            }
        },
        reloadOrders() {
            if (!this.loading) {
                this.loading = true;
                setTimeout(() => {
                    this.getListaPedidos(this.page);
                }, 2000);
            }
        },
        setCotacao(text) {
            this.$store.commit("setBuscaCotacao", text);
        },
        setOrderSearch(text) {
            this.buscaPedido = text;
        },
        setCompany(value) {
            this.selectedLoja = value;
        },
        setSuplier(value) {
            this.$store.commit("setSelectedFornecedor", value);
        },
        setStatus(value) {
            this.filters.status = value;
        },
        getTotal(order) {
            return order.itens.reduce(
                (x, { preco_embalagem, quantidade }) =>
                    x + preco_embalagem * quantidade,
                0
            );
        },
        translateStatus(status) {
            switch (status) {
                case "AGUARDANDO_CONFIRMACAO":
                    return "AGUARDANDO CONFIRMACAO";
                case "CONFIRMADO":
                    return "CONFIRMADO";
                default:
                    return "Não identificado!";
            }
        },
        paginate() {
            this.page = this.page + 1;
            this.getDirectSaleOrders();
        },
        confirm_delivery(order, index) {
            this.confirm_action({
                message: "Confirma recebimento do pedido?",
                deny_text: "Com divergência!",
                cancel_buttom_color: "#4D4F5C",
                callback: (result) => {
                    this.svc.confirm_delivery(order.id_pedido).then((res) => {
                        order.status_recebido = true;
                        this.reloadOrders();
                    });
                },
                deny_callback: () => {
                    this.svc.confirm_delivery(order.id_pedido);
                    this.$router.push({
                        name: "cliente-monitores-divergent",
                        params: {
                            id: order.id_cotacao,
                            sellerid: order.usu_id,
                            sid: order.id_loja,
                            providerid: order.for_id,
                        },
                    });
                },
            });
        },
        sendToDivergency(order) {
            this.$router.push({
                name: "cliente-monitores-divergent",
                params: {
                    id: order.id_cotacao,
                    sellerid: order.usu_id,
                    sid: order.id_loja,
                    providerid: order.for_id,
                },
            });
        },
        confirm_delivery_status_p(order) {
            this.confirm_action({
                message: "Confirma recebimento do pedido?",
                cancel_buttom_color: "#4D4F5C",
                callback: (result) => {
                    this.svc
                        .confirm_delivery_status_p(order.id_pedido)
                        .then((res) => {
                            order.status_recebido = true;
                            this.reloadOrders();
                        });
                },
            });
        },
        updatePage(new_page) {
            this.getListaPedidos(new_page);
        },
        postAvaliacaoPedido() {
            let arrayCheck = [];
            this.checkbox.forEach((data, index) => {
                if (data) {
                    arrayCheck.push(this.arrayCheckbox[index].id);
                }
            });
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            };
            axios
                .post(
                    `${CONSTANTS.API_URL}/atualizaravaliacaopedido`,
                    {
                        id_pedido: this.indexIdPedido,
                        nota: this.rating,
                        comentarios: arrayCheck,
                        observacao: " ",
                    },
                    config
                )
                .then(() => {
                    this.hide();
                    this.getListaPedidos(this.paginaAtual);
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        hide() {
            this.$modal.hide("hello-world");
            this.rating = 0;
            this.select = "";
            this.checkbox = [];
        },
        modalClick() {
            if (this.rating === 1) {
                this.notaVendedor = "Vendedor péssimo, poderia melhorar.";
            }
            if (this.rating === 2) {
                this.notaVendedor = "Vendedor ruim, poderia melhorar.";
            }
            if (this.rating === 3) {
                this.notaVendedor = "Vendendor regular, poderia melhorar.";
            }
            if (this.rating === 4) {
                this.notaVendedor = "Vendedor bom, mas poderia melhorar.";
            }
            if (this.rating === 5) {
                this.notaVendedor = "Vendedor Excelente!";
            }
        },
        show(index) {
            this.$modal.show("hello-world");
            this.indexArray = this.arrayPedido[index].vendedor;
            this.indexIdPedido = this.arrayPedido[index].id_pedido;
            this.rating = this.arrayPedido[index].nota;
            this.checkbox = this.arrayCheckbox.map((opts) => {
                let opt = this.arrayPedido[index].avaliacao.find(
                    (item) => item.id == opts.id
                );
                return opt ? true : false;
            });
        },
        getArrayPedido() {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            };
            axios
                .get(`${CONSTANTS.API_URL}/listarcomentariospedido`, config)
                .then((data) => {
                    this.arrayCheckbox = data.data.comentarios;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        getDirectSaleOrders() {
            // this.is_loading = true;
            // this.service.getDirectSaleOrders({ page: this.page, page_size: this.items_by_page_value })
            // .then(response => response.data)
            // .then(data => {
            //     this.is_loading = false;
            //     this.orders = this.orders.concat(data.data);
            //     this.showPagination = data.next_page_url != null;
            // }).catch(error => {
            //     this.is_loading = false;
            //     ErrorHandlerService.handle(error, this.$store);
            // });;
        },
        print(order) {
            this.current_order = order;

            const [id_pedido, id_cotacao, id_loja, usu_id] = [
                [order.id_pedido],
                [order.id_cotacao],
                [order.id_loja],
                [order.usu_id],
            ];

            const dados = {
                id_pedido: id_pedido,
                id_cotacao: id_cotacao,
                id_loja: id_loja,
                usu_id: usu_id,
            };

            this.orderService
                .get_order_data(dados)
                .then((response) => response.data)
                .then((data) => {
                    this.order_data = data.data;
                    console.log("print order", order);
                    Vue.nextTick(() => {
                        window.document.title = `pedido-${order.id_pedido}.pdf`;
                        this.$htmlToPaper(
                            "print-order",
                            { name: "pedido.pdf" },
                            () => {
                                this.current_order = null;
                                this.order_data = null;
                                window.document.title = "Club da Cotação";
                            }
                        );
                    });
                });
        },
        isChecked() {
            let check = false;
            this.arrayPedido.forEach((element) => {
                if (element.isCheck) check = true;
            });
            return check;
        },
        printClick() {
            let check = false;
            this.arrayPedido.forEach((element) => {
                if (element.isCheck) check = true;
            });
            if (!check) {
                this.$swal.fire(
                    "Por Favor,",
                    "Selecione ao menos uma cotação."
                );
                return;
            }
            this.$swal
                .fire({
                    icon: "info",
                    title: "Deseja juntar as paginas?",
                    text: "Deseja que as informações sejam agrupados no menor numero de paginas posiveis?",
                    iconHtml:
                        '<span class="material-icons-outlined print-icon" style="font-size: 1em">print</span>',
                    showDenyButton: true,
                    denyButtonText: "Não",
                    denyButtonColor: "red",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Sim",
                })
                .then((resp) => {
                    if (resp.isConfirmed) this.print_many(true);
                    else if (resp.isDenied) this.print_many(false);
                });
        },
        print_many(value) {
            this.is_loading_pdf = true;

            this.selectPedidos = this.arrayPedido.filter(
                (order) => order.isCheck
            );
            const [id_pedido, id_cotacao, id_loja, usu_id] = [
                this.selectPedidos.map((item) => item.id_pedido),
                this.selectPedidos.map((item) => item.id_cotacao),
                this.selectPedidos.map((item) => item.id_loja),
                this.selectPedidos.map((item) => item.usu_id),
            ];
            const dados = {
                id_pedido: id_pedido,
                id_cotacao: id_cotacao,
                id_loja: id_loja,
                usu_id: usu_id,
            };
            this.orderService
                .get_order_data(dados)
                .then((response) => response.data)
                .then((data) => {
                    this.order_data = data.data;
                    this.printColapsed = value;
                    Vue.nextTick(() => {
                        // window.document.title = `pedidos.pdf`
                        this.$htmlToPaper(
                            "print-order",
                            { name: "pedido.pdf" },
                            () => {
                                this.current_order = null;
                                this.order_data = null;
                                // window.document.title = 'Club da Cotação'
                            }
                        );
                    });
                });
        },
        getLojas() {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            };
            return axios
                .get(`${CONSTANTS.API_URL}/getrequisitantescliente`, config)
                .then((data) => {
                    data.data.requisitantes.forEach((element) => {
                        this.arraySelectLoja.push({
                            text: element.loj_nomeFantasia,
                            value: element,
                        });
                    });
                    if (
                        !this.can("REQUEST_ORDER", "READ_ALL") ||
                        JSON.parse(localStorage.getItem("store_id"))
                    ) {
                        this.selectedLoja = this.arraySelectLoja[0].value;
                        this.lockStore = true;
                    }
                    this.getListaPedidos(1);
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        getListaPedidos(page) {
            this.loading = true;
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                params: {
                    idPedido: this.buscaPedido,
                    numerocotacao: this.buscaCotacao,
                    fornecedor: this.selectedFornecedor
                        ? this.selectedFornecedor.for_id
                        : null,
                    loja: this.selectedLoja ? this.selectedLoja.loj_id : null,
                    datainicial: !this.buscaCotacao
                        ? moment(this.dateInit).format().split("T")[0]
                        : null,
                    datafinal: !this.buscaCotacao
                        ? moment(this.dateEnd).format().split("T")[0]
                        : null,
                    entregaInit: this.deliveryInit
                        ? moment(this.deliveryInit).format().split("T")[0]
                        : null,
                    entregaFinal: this.deliveryInit
                        ? moment(this.deliveryEnd).format().split("T")[0]
                        : null,
                    singleorder: false,
                    status: this.filters.status ? this.filters.status : null,
                    identifier: this.identifier,
                },
            };
            let url = `${CONSTANTS.API_URL}/listarpedidos?page=${page}`;
            axios
                .get(url, config)
                .then((data) => {
                    this.arrayPedido = data.data.pedidos.data;
                    this.loading = false;
                    this.paginaAtual = data.data.pedidos.current_page;
                    this.totalPaginas = data.data.pedidos.last_page;
                    this.total_items = data.data.pedidos.total;
                })
                .catch((error) => {
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        getFornecedor() {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            };
            axios
                .get(`${CONSTANTS.API_URL}/getfornecedorescliente`, config)
                .then((data) => {
                    data.data.fornecedores.forEach((element) => {
                        this.arraySelectFornecedor.push({
                            text: element.for_nome,
                            value: element,
                        });
                    });
                    this.getLojas();
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        resend_notification(order_id) {
            this.confirm_action({
                message: "Confirma envio de notificação?",
                subtitle:
                    "O vendedor será novamente notificado sobre este pedido!",
                callback: () => {
                    this.v2orderService.notify_legacy(order_id).then(() => {
                        this.present_info("Notificação reenviada com sucesso!");
                    });
                },
            });
        },
        edit_product(seller, current) {
            if (seller.edi_children) {
                let di = seller.edi_children.find((d) => d.status == "FAILED");
                if (di) {
                    this.prod_svc.load(di.data_id).then((response) => {
                        this.product = response.data;
                        this.current_seller = current;
                    });
                }
            }
        },
        filtrarPedidos() {
            this.getListaPedidos(1);
        },
        formatCNPJ(cnpj) {
            if (!cnpj) return "";
            cnpj = String(cnpj).padStart(14, "0");
            return cnpj
                .replace(/^(\d{2})(\d)/, "$1.$2")
                .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/\.(\d{3})(\d)/, ".$1/$2")
                .replace(/(\d{4})(\d)/, "$1-$2")
                .substring(0, 18);
        },
        formatPhone(phone) {
            if (!phone) return "--";
            const nums = phone.replace(/\D/g, "");
            return nums.length === 11
                ? nums.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
                : nums.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        },
        truncateText(text, length) {
            if (!text) return text;
            if (text.length > length) {
                return text.substring(0, length) + "...";
            }
            return text;
        },
        toggleMenu(index) {
            this.openMenuIndex = this.openMenuIndex === index ? null : index;
        },
        closeMenu() {
            this.openMenuIndex = null;
        },
        exportTxt() {
            const selectedOrders = this.arrayPedido.filter(o => o.isCheck);
            const params = {};

            if (selectedOrders.length > 0) {
                params.order_ids = selectedOrders.map(o => o.id_pedido).join(',');
            } else {
                if (!this.buscaCotacao) {
                    params.from = moment(this.dateInit).format().split('T')[0];
                    params.to = moment(this.dateEnd).format().split('T')[0];
                }
                if (this.deliveryInit) {
                    params.entrega_init = moment(this.deliveryInit).format().split('T')[0];
                }
                if (this.deliveryEnd) {
                    params.entrega_final = moment(this.deliveryEnd).format().split('T')[0];
                }
                if (this.filters.status) params.status = this.filters.status;
                if (this.selectedLoja) params.cnpj = this.selectedLoja.loj_cnpj;
                if (this.selectedFornecedor) params.cnpj_for = this.selectedFornecedor.for_cnpj;
            }

            this.v3orderService.exportTxt(params).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/plain' }));
                const a = document.createElement('a');
                a.href = url;
                a.download = 'pedidos.txt';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }).catch(error => {
                ErrorHandlerService.handle(error, this.$store);
            });
        },
        resyncOrder(id_pedido) {            this.$swal
                .fire({
                    title: "Deseja sincronizar novamente este pedido?",
                    text: "Esta operação ira enviar o pedido novamente para a retaguarda.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, sincronizar novamente.",
                })
                .then((resp) => {
                    if (!resp.isConfirmed) return;
                    this.present_loader("Ressincronizando...");
                    this.req_svc.resyncOrder(id_pedido).then((resp2) => {
                        this.dismiss_loader();
                        this.reloadOrders();
                    });
                });
        },
    },
    watch: {
        items_by_page_value: function () {
            this.orders = [];
            this.getDirectSaleOrders();
        },
        // dateEnd() {
        //   if (this.loading) return;
        //   if (this.dateInit) this.getListaPedidos(1);
        // },
        // dateInit() {
        //   if (this.loading) return;
        //   if (this.dateEnd) this.getListaPedidos(1);
        // },
    },
    mounted() {
        this.getFornecedor();
        window.scrollTo(0, 0);
        this.getArrayPedido();
        document.addEventListener("click", this.closeMenu);
        // this.getDirectSaleOrders();
        if (this.request_id)
            this.$store.commit("setBuscaCotacao", this.request_id);
    },
    beforeDestroy() {
        //     console.log(1231231231);
        //     this.$store.commit('setSelectedFornecedor', undefined)
        //     this.$store.commit('setBuscaCotacao', undefined)
        document.removeEventListener("click", this.closeMenu);
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_variables";
.order-page-container {
    font-size: 1rem;
    padding-right: 1vh;
}
.page-route-select {
    display: flex;
    align-items: center;
}
.page-route-select-text {
    font-weight: 400;
    font-size: 1.36em;
    color: #ababab;
    margin-right: 20px;
    cursor: pointer;
}
.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}
.order-page-print-button {
    width: 12%;
}
.order-page-title {
    font-weight: 600;
    font-size: 2.5em;
    letter-spacing: 0.15px;
    color: #605f5f;
    margin-top: 20px;
}
.page-table-line-special {
    background: #f7f7f7;
}
.order-page-info-containear {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 1vh;
}
.order-page-filter-container {
    display: flex;
    margin-top: 2vh;
    align-items: flex-end;
}
.order-page-table-header {
    margin-top: 4vh;
    background: #fffefc;
    border: 0.5px solid #e5e5e5;
    font-weight: 600;
    font-size: 1.19em;
    color: #605f5f;
    padding: 0.7vh 0;
    display: flex;
    align-items: center;
    margin-bottom: 2vh;
}
.order-table .checkbox-width {
    text-align: center;
    color: var(--primary-color);
    cursor: pointer;
}
.id-width {
    width: 10%;
    text-align: center;
}
.store-width {
    width: 14%;
    text-align: center;
    padding: 0 0.5%;
}
.date-width {
    width: 9%;
    text-align: center;
}
.price-width {
    width: 7%;
    text-align: center;
}
.seller-width {
    flex: 1;
    text-align: center;
}
.value-width {
    white-space: nowrap;
}
.status-width {
    width: 7%;
    text-align: center;
}
.confirmationdate-width {
    width: 11%;
    text-align: center;
}
.confirmationdate-header-text {
    font-size: 0.8em;
}
.suplier-width {
    width: 14%;
    text-align: center;
}
.review-width {
    width: 7%;
    text-align: center;
}
.actions-width {
    position: sticky;
    right: 0;
    z-index: 3;
    background: #fff;
}
.page-filters__right-wrapper {
    width: 25vw;
}
.page-filters__right-title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-size: 1.2em;
}
.page-filters__right-title {
    font-weight: 400;
    font-size: 1.7em;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #898989;
}
.page-filters__right-select-wrapper {
    display: flex;
    align-items: center;
}
.date-icon {
    background-color: var(--primary-color);
    color: #fff;
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 0px 8px 8px 0px;
    position: relative;
    left: -6px;
}
.order-print-check {
    position: absolute;
    background-color: white;
    top: 45%;
    left: 35%;
    width: 35%;
    height: 20%;
    border: 1px solid var(--primary-color);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.order-print-button {
    width: 7vw;
    border-radius: 10px;
    height: 5vh;
}
.order-print-button-yes {
    background-color: lightgreen;
    color: white;
    margin-right: 3vw;
}
.order-print-button-no {
    background-color: lightcoral;
    color: white;
}
.order-table-seller-content {
    text-align: left;
    padding-left: 5%;
}
.order-table-store-content {
    text-align: left;
}
.order-page-table {
    display: flex;
    font-weight: 300;
    font-size: 1em;
    color: #605f5f;
    align-items: center;
    padding: 2vh 0;
}
.order-page-table-separator {
    border-right: 0.5px solid #dde5e9;
}
.order-page-filter-section1 {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 1.5vh;
}
.selected-options-containear {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    column-gap: 1.5vw;
    min-height: 7vh;
}
.selected-option {
    background: #fcf9f7;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1vh 5%;
    font-weight: 300;
    font-size: 11px;
    letter-spacing: 0.15px;
    color: var(--primary-color);
    margin-top: 1vh;
}
.order-page-filter-section2 {
    display: flex;
    flex: 1;
    justify-content: space-between;
}
.tablet {
    display: none;
}
.mobile {
    display: none;
}
.order-table-mobile-header {
    display: none;
}
.notification-icon {
    color: var(--primary-color);
    cursor: pointer;
    font-size: 1.5em;
}
.whatsapp-tick {
    cursor: default;
    color: gray;
}
.whatsapp-read {
    cursor: default;
    color: blue;
}
.whatsapp-error {
    cursor: default;
    color: #cd2a2a;
}
.integration-pending {
    cursor: default;
    color: orange;
}

::v-deep(.input-containear) {
    height: 4.5vh !important;
}
.print-button {
    height: 6vh;
}
.filter-button {
    height: 6vh;
}
.status-cell {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
}

.status-text {
    font-size: 0.85em;
    font-weight: 500;
}

.whatsapp-tick {
    color: gray;
}

.whatsapp-read {
    color: blue;
}

.error {
    color: #cd2a2a;
}

.integration-ok {
    color: #4caf50;
}

.warning {
    color: orange;
}

.material-icons,
.fas {
    font-size: 1.3rem;
}
.order-table {
    width: 100%;
    border-collapse: collapse;
}

.order-table th,
.order-table td {
    border-bottom: 1px solid #ddd;
    text-align: left;
}

.order-table th {
    background: #f5f5f5;
    text-align: center;
}

.value-badge {
    background: green;
    color: white;
    padding: 4px 10px;
    border-radius: 10px;
    opacity: 0.7;
    overflow: hidden;
}
.negative-badge {
    background: red;
    color: white;
    padding: 4px 10px;
    border-radius: 10px;
    opacity: 0.7;
    overflow: hidden;
}
.buttons {
    justify-content: flex-end;
    display: flex;
    flex-direction: row;
    padding: 5px;
    gap: 10px;
    left: auto;
}
.status-pending {
    color: orange;
}
.preorder-zap-hover {
    color: #4ac959;
}
.preorder-zap-container {
    display: flex;
    align-items: center;
    padding: 5px 5px;
    gap: 5px;
    font-size: 0.9em;
}
.actions-dropdown {
    position: absolute;
    right: 75%;
    top: 50%;
    background: white;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    border-top-right-radius: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    min-width: 200px;
    padding: 5px 0;
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 0.9em;
    color: #605f5f;
}

.dropdown-item:hover {
    background: #f7f7f7;
}

.dropdown-item span {
    font-size: 1.5em;
}

.dropdown-item.danger {
    color: #ff0000;
}

.dropdown-item.success {
    color: #30aa4c;
}

.star {
    color: #ffca2b;
}

.pdf {
    color: #cd2a2a;
}

.table-container {
    width: 100%;
    overflow-x: auto;
}
@media only screen and (max-width: 800px) {
    .order-page-filter-container {
        flex-direction: column;
    }
    .desktop {
        display: none !important;
    }
    .tablet {
        display: block;
    }
    .order-page-filter-section1 {
        margin-bottom: 2vh;
    }
    .order-page-container {
        font-size: 1.25vw;
    }
    .order-page-filter-section1 {
        margin-bottom: 0;
    }

    .tablet {
        display: none;
    }
    .mobile {
        display: block;
    }
    .order-page-filter-section2 {
        width: 100%;
        display: flex;
    }
    .page-filters__right-title-wrapper {
        margin-top: 1vh;
    }
    .order-page-filter-section1 {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    .mobile-table-row {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }
    .mobile-expand-icon {
        font-size: 1.5em;
        color: var(--primary-color);
    }
    .order-page-info-containear {
        flex-direction: column;
        align-items: flex-start;
    }
    .order-page-print-button {
        width: 40%;
        margin-top: 2vh;
    }
    .order-page-container {
        font-size: 2vw;
    }
    .order-page-table-header {
        display: none;
    }
    .order-page-table {
        flex-direction: column;
        gap: 1vh;
        margin-bottom: 3vh;
        font-size: 1.5em;
    }
    .order-page-table-separator {
        border-right: none;
        width: 100%;
        flex: unset;
        display: flex;
        justify-content: space-between;
        padding-right: 3vw;
    }
    .order-table-mobile-header {
        display: flex;
        font-weight: 700;
        font-size: 1.1em;
        text-align: inherit;
    }
    .hide-mobile-filters {
        display: none;
    }
    .order-table-seller-content {
        text-align: end;
    }
    .order-table td,
    .order-table th {
        z-index: 1;
    }
    .actions-width {
        position: sticky;
        right: 0;
        z-index: 5;
        background: #fff;
    }
    .white-bg {
        background: #fff;
    }
    .checkbox-width {
        color: unset;
        justify-content: flex-start;
        gap: 3vw;
        font-size: 1.1em;
        align-items: center;
    }
    .mobile-id-row {
        display: flex;
        align-items: center;
        gap: 1.5vw;
    }
    .page-filters__right-wrapper {
        width: 100%;
    }
    .mobile-filter-button {
        display: flex;
    }
    .mobile-buttons-row {
        display: flex;
        gap: 10%;
        margin-top: 2vh;
        width: 100%;
        justify-content: space-between;
    }
}
@media only screen and (max-width: 500px) {
    .order-page-container {
        font-size: 3vw;
    }
}
@media only screen and (max-width: 200px) {
    .order-page-container {
        font-size: 3.25vw;
    }
}
</style>
